import { getOwaWorkload } from 'owa-workloads';
import { GeneralOptions } from 'owa-options-general';
import { MailOptions } from 'owa-options-mail';
import { CalendarOptions } from 'owa-options-calendar';
export default function getDefaultCategory() {
    switch (getOwaWorkload()) {
        case 1 /* Mail */:
        case 16 /* MailMini */:
            return MailOptions.key;
        case 2 /* Calendar */:
            return CalendarOptions.key;
        default:
            return GeneralOptions.key;
    }
}
//# sourceMappingURL=getDefaultCategory.js.map